<template>
    <div id="cta-element" :class="{empty: !moduleData}">
        <div class="module" v-if="moduleData" :class="moduleData.Background + ' ' + moduleData.Spacing"
             :id="moduleData.AnchorID">
            <div class="container">
                <p v-if="moduleData.Content" v-html="moduleData.Content"></p>
                <div class="cta-actions">
                    <a class="btn btn-dark shadow-heavy" v-if="moduleData.CTA && moduleData.CTA.ID"
                       :href="moduleData.CTA.URL" :target="moduleData.CTA.NewTab ? '_blank' : false">{{ moduleData.CTA.CTAText }}</a>
                    <a class="btn btn-dark shadow-heavy" v-if="moduleData.CTASecondary && moduleData.CTASecondary.ID"
                       :href="moduleData.CTASecondary.URL" :target="moduleData.CTASecondary.NewTab ? '_blank' : false">{{ moduleData.CTASecondary.CTAText }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "CTAElement",
    props: {
        component: {
            type: Object,
        }
    },
    computed: {
        ...mapGetters(['getModuleData', 'getSettings']),
        moduleData() {
            return this.getModuleData(this.component.ID);
        }
    }
}
</script>
